export { APPOINTED_CARRIERS_TAB_ID } from 'helpers/carriers/carriers';

export const ALL_CARRIERS_TAB_ID = 'all-carriers';
